import { render } from "./SalesHorizonChart.vue?vue&type=template&id=76632736&ts=true"
import script from "./SalesHorizonChart.vue?vue&type=script&lang=ts"
export * from "./SalesHorizonChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__